var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTUsers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Users"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Users",
    clipPath: "url(#clip-Users)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-users",
    "data-name": "Icon awesome-users",
    d: "M72.23,132.753c26.56,0,48.153-19.508,48.153-43.5s-21.594-43.5-48.153-43.5-48.154,19.508-48.154,43.5S45.671,132.753,72.23,132.753Zm337.075,0c26.56,0,48.153-19.508,48.153-43.5s-21.594-43.5-48.153-43.5-48.154,19.508-48.154,43.5S382.745,132.753,409.3,132.753ZM433.382,154.5H385.228a50.732,50.732,0,0,0-33.933,12.643c30.322,15.021,51.84,42.142,56.505,74.36h49.658c13.317,0,24.077-9.72,24.077-21.751V198C481.535,174.011,459.941,154.5,433.382,154.5Zm-192.614,0c46.574,0,84.269-34.053,84.269-76.127S287.341,2.25,240.768,2.25,156.5,36.3,156.5,78.377,194.194,154.5,240.768,154.5Zm57.784,21.751h-6.245a127.563,127.563,0,0,1-103.079,0h-6.245c-47.853,0-86.676,35.073-86.676,78.3v19.576c0,18.012,16.177,32.626,36.115,32.626H349.113c19.939,0,36.115-14.614,36.115-32.626V254.556C385.228,211.327,346.4,176.254,298.552,176.254ZM130.24,167.146A50.732,50.732,0,0,0,96.307,154.5H48.154C21.594,154.5,0,174.011,0,198v21.751c0,12.031,10.759,21.751,24.077,21.751H73.66C78.4,209.288,99.919,182.168,130.24,167.146Z",
    transform: "translate(9 95.75)",
    fill: "#6e2b69"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTUsers);
export default __webpack_public_path__ + "static/media/TUsers.07d7f3470cb42b379e76bfa28b23a4ad.svg";
export { ForwardRef as ReactComponent };